import { render, staticRenderFns } from "./patient-brief.vue?vue&type=template&id=67056a28&"
import script from "./patient-brief.component.ts?vue&type=script&lang=ts&"
export * from "./patient-brief.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports